export const DnDHOCCompat = $hasDep('react-dnd', '5') ?
// eslint-disable-next-line
require('./DnDHOCLatest').DnDHOCLatest :
// eslint-disable-next-line
require('./DnDHOCLegacy').DnDHOCLegacy;